import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { Link } from 'react-router-dom';
import { Loading, Header, Nav, H1, Error, modalStyles } from './../../common';
import { Edit, Delete, Text } from './../../buttons';
import {
	matchFetch,
	toggleEdit,
	matchUpdate,
	onSeasonIdTextChange,
	onPostIdTextChange,
	onNameTextChange,
	onFormationChange,
	onActiveChange,
	matchNew,
	matchDelete,
} from './../../../actions/MatchActions';
import { TextInput, Select, Checkbox } from '../../inputs';
import './Match.css';

class Match extends Component {
	constructor(props) {
		super(props);
		this.state = {
			postId: '',
			season: {
				0: { name: '2018-19', id: 0 },
				1: { name: '2019-20', id: 1 },
				2: { name: '2020-21', id: 2 },
				3: { name: '2021-22', id: 3 },
				4: { name: '2022-23', id: 4 },
				5: { name: '2023-24', id: 5 },
			},
			selectedSeasonIndex: 5,
			seasonById: [0, 1, 2, 3, 4, 5],
			season_id: 5,
			name: '',
			modal: false,
			toDelete: '',
			toDeleteId: '',
			formation: {
				1: { name: '442', id: 1 },
				2: { name: '352', id: 2 },
				3: { name: '433', id: 3 },
			},
			formationById: [1, 2, 3],
			formationIndex: 0,
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.onSeasonIdTextChange = this.props._onSeasonIdTextChange.bind(this);
		this.onPostIdTextChange = this.props._onPostIdTextChange.bind(this);
		this.onNameTextChange = this.props._onNameTextChange.bind(this);
		this.onFormationChange = this.props._onFormationChange.bind(this);
		this.onActiveChange = this.props._onActiveChange.bind(this);
		this.toggleEdit = this.props._toggleEdit.bind(this);
		this.matchUpdate = this.props._matchUpdate.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleModalClose = this.handleModalClose.bind(this);
		this.handleSelectedSeasonChange = this.handleSelectedSeasonChange.bind(this);
	}
	componentWillMount() {}
	componentDidMount() {
		this.props._matchFetch(this.state.season[this.state.selectedSeasonIndex].name);
	}

	handlePostIdChange = v => this.setState({ postId: v });

	handleSeasonIdChange = v => this.setState({ season_id: 5 });

	handleNameChange = v => this.setState({ name: v });

	handleFormatonChange = v => {
		if (v === '*Formation') return null;
		this.setState({ formationIndex: v });
	};

	handleSelectedSeasonChange = v => {
		this.setState({ selectedSeasonIndex: v }, () => {
			this.props._matchFetch(this.state.season[this.state.selectedSeasonIndex].name);
		});
	};

	handleDelete() {
		this.props._matchDelete(
			this.state.toDeleteId,
			this.state.season[this.state.selectedSeasonIndex].name,
		);
		this.setState({ modal: false, toDelete: '' });
	}

	handleModalClose() {
		this.setState({ modal: false });
	}

	handleSubmit(event) {
		event.preventDefault();
		if (this.state.name === '') {
			return null;
		}
		if (this.state.season_id === null) {
			return null;
		}
		if (this.state.postId === '' || isNaN(this.state.postId)) {
			return null;
		}
		if (this.state.formationIndex === 0) {
			return null;
		}
		this.props._matchNew({
			postId: parseInt(this.state.postId, 10),
			season: this.state.season[this.state.selectedSeasonIndex].name,
			title: this.state.name,
			bonus: '',
			description: '',
			formation: this.state.formation[this.state.formationIndex].name,
			formation_id: parseInt(this.state.formationIndex, 10),
			active: true,
			manager: 'arteta',
		});
		this.setState({
			postId: '',
			season_id: 5,
			name: '',
			formationIndex: 0,
		});
	}

	_loading() {
		if (this.props.loading) return <Loading />;
		if (this.props.loadingSeason) return <Loading />;
		return null;
	}

	_renderList() {
		const title = (
			<li className="flexContainerRow">
				<div className="item small">
					<div className="listTitle">Post ID</div>
				</div>
				<div className="item small">
					<div className="listTitle">Season</div>
				</div>
				<div className="item">
					<div className="listTitle">Title</div>
				</div>
				<div className="item small">
					<div className="listTitle">Formation</div>
				</div>
				<div className="item" />
			</li>
		);
		const items = this.props.listByID.map(v => (
			<li key={v} className="flexContainerRow forms">
				<div className="item small">
					<TextInput
						inputId={'post_id' + this.props.list[v].id}
						placeholder={this.props.list[v].postId}
						label={null}
						value={
							this.props.list[v].readOnly
								? this.props.list[v].postId
								: this.props.list[v].onChange.postId
						}
						onTextChange={val => this.onPostIdTextChange(v, val)}
						readonly={this.props.list[v].readOnly}
					/>
				</div>
				<div className="item small">
					{this.props.list[v].readOnly ? (
						<TextInput
							inputId={'season_id' + this.props.list[v].id}
							placeholder={this.state.season[this.state.selectedSeasonIndex].name}
							label={null}
							value={this.state.season[this.state.selectedSeasonIndex].name}
							readonly={this.props.list[v].readOnly}
						/>
					) : (
						<Select
							prompt="*Season"
							currentVal={this.state.season_id}
							options={this.state.season}
							optionsById={this.state.seasonById}
							onChange={val => this.onSeasonIdTextChange(v, parseInt(val, 10))}
						/>
					)}
				</div>
				<div className="item">
					<TextInput
						inputId={'name' + this.props.list[v].id}
						placeholder={this.props.list[v].title}
						label={null}
						value={
							this.props.list[v].readOnly
								? this.props.list[v].title
								: this.props.list[v].onChange.title
						}
						onTextChange={val => this.onNameTextChange(v, val)}
						readonly={this.props.list[v].readOnly}
					/>
				</div>
				<div className="item small">
					{this.props.list[v].readOnly ? (
						<TextInput
							inputId={'formation' + this.props.list[v].id}
							placeholder={this.props.list[v].formation}
							label={null}
							value={this.props.list[v].formation}
							readonly={this.props.list[v].readOnly}
						/>
					) : (
						<Select
							prompt="*Formation"
							currentVal={this.props.list[v].onChange.formation_id}
							options={this.state.formation}
							optionsById={this.state.formationById}
							onChange={val =>
								val === '*Formation'
									? this.onFormationChange(v, {
											name: this.state.formation[this.props.list[v].onChange.formation_id].name,
											id: this.props.list[v].onChange.formation_id,
									  })
									: this.onFormationChange(v, {
											name: this.state.formation[parseInt(val, 10)].name,
											id: parseInt(val, 10),
									  })
							}
						/>
					)}
				</div>
				<div className="item">
					<div className="flexContainerRow">
						{this.props.list[v].readOnly ? (
							<div>
								<Edit action={() => this.toggleEdit(v)} />
							</div>
						) : (
							<div className="buttonText small">
								<Text
									text="Save"
									action={() => this.matchUpdate(this.props.list[v].onChange, v.toString())}
								/>
							</div>
						)}
						{this.props.list[v].readOnly ? (
							<div>
								<Delete
									action={() =>
										this.setState({
											modal: true,
											toDelete: this.props.list[v].title,
											toDeleteId: v.toString(),
										})
									}
								/>
							</div>
						) : (
							<div className="buttonText">
								<Text text="Cancel" action={() => this.toggleEdit(v)} />
							</div>
						)}
						{this.props.list[v].readOnly ? (
							<div className="buttonText">
								<Link to={'matches/' + v} title="match squad">
									<i className={'fa fa-users'} />
								</Link>
							</div>
						) : (
							<div />
						)}
						{this.props.list[v].error ? <Error text={this.props.list[v].errorText} /> : null}
					</div>
				</div>
			</li>
		));
		return (
			<ul>
				{title}
				{items}
			</ul>
		);
	}

	render() {
		return (
			<div>
				<Header />
				<div className="container">
					<Nav />
					<div className="match matchAdmin">
						<H1 text={'Matches'} />
						<p>
							Create an Arsenal match to sync with Wordpress. You can select the match day squad
							after the match is created.
						</p>
						<div className="section forms">
							<form className="flexContainerRow">
								<div className="item small">
									<TextInput
										inputId={'post_id'}
										placeholder="*Post Id"
										label={null}
										value={this.state.postId}
										onTextChange={this.handlePostIdChange}
									/>
								</div>
								<div className="item small">
									<Select
										prompt="*Season"
										currentVal={this.state.season_id}
										options={this.state.season}
										optionsById={this.state.seasonById}
										onChange={this.handleSeasonIdChange}
									/>
								</div>
								<div className="item">
									<TextInput
										inputId={'name'}
										placeholder="*Title"
										label={null}
										value={this.state.name}
										onTextChange={this.handleNameChange}
									/>
								</div>
								<div className="item small">
									<Select
										prompt="*Formation"
										currentVal={this.state.formationIndex}
										options={this.state.formation}
										optionsById={this.state.formationById}
										onChange={this.handleFormatonChange}
									/>
								</div>
								<div className="item small">
									<div className="buttonText">
										<Text text="Create" action={this.handleSubmit} />
									</div>
								</div>
							</form>
						</div>
						<div className="flexContainerRow">
							<div className="item">
								<p>Edit existing Arsenal match.</p>
							</div>
							<div className="item small">
								<Select
									currentVal={this.state.selectedSeasonIndex}
									options={this.state.season}
									optionsById={this.state.seasonById}
									onChange={this.handleSelectedSeasonChange}
								/>
							</div>
						</div>
						{this._renderList()}
					</div>
				</div>
				{this._loading()}
				<ReactModal
					isOpen={this.state.modal}
					onRequestClose={this.handleModalClose}
					style={modalStyles}
					ariaHideApp={false}
					contentLabel="Confirm">
					<h2 style={{ textAlign: 'center' }}>Delete match: {this.state.toDelete}</h2>
					<div style={{ display: 'flex', justifyContent: 'space-between' }}>
						<div style={{ flex: 1 }}>
							<Text text="Delete" action={this.handleDelete} />
						</div>
						<div style={{ flex: 1 }}>
							<Text text="Cancel" action={this.handleModalClose} />
						</div>
					</div>
				</ReactModal>
			</div>
		);
	}
}

const mapStateToProps = ({ match }) => {
	const { loading, errorText, list, listByID } = match;

	return {
		loading,
		errorText,
		list,
		listByID,
	};
};

const mapDispatchToProps = dispatch => ({
	_matchFetch: season => dispatch(matchFetch(season)),
	_toggleEdit: id => dispatch(toggleEdit(id)),
	_matchUpdate: (obj, doc) => dispatch(matchUpdate(obj, doc)),
	_onSeasonIdTextChange: (id, text) => dispatch(onSeasonIdTextChange(id, text)),
	_onPostIdTextChange: (id, text) => dispatch(onPostIdTextChange(id, text)),
	_onNameTextChange: (id, text) => dispatch(onNameTextChange(id, text)),
	_onFormationChange: (id, obj) => dispatch(onFormationChange(id, obj)),
	_onActiveChange: (id, text) => dispatch(onActiveChange(id, text)),
	_matchNew: obj => dispatch(matchNew(obj)),
	_matchDelete: (doc, season) => dispatch(matchDelete(doc, season)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Match);



// WEBPACK FOOTER //
// ./src/components/screens/match/Match.js